import type { JSX } from 'react';
import { DataTableFilters } from '@/shared/components/DataTableFilters';
import type { FilterState, FilterValue } from '@/shared/types/table-filters.types';
import { candidateTableColumns } from '../config/candidateTableColumns';

export interface CandidateFiltersProps {
  filters: FilterState;
  activeFilterCount: number;
  onFilterChange: (key: string, value: FilterValue | undefined) => void;
  onClearFilters: () => void;
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

/** Candidate-specific binding of the shared list toolbar. */
export function CandidateFilters({
  filters,
  activeFilterCount,
  onFilterChange,
  onClearFilters,
  searchTerm,
  onSearchChange,
}: CandidateFiltersProps): JSX.Element {
  return (
    <DataTableFilters
      columns={candidateTableColumns}
      filters={filters}
      activeFilterCount={activeFilterCount}
      onFilterChange={onFilterChange}
      onClearFilters={onClearFilters}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
    />
  );
}
